import React, { useState, useEffect } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { useNavigate } from "react-router-dom";
import ItemService from "../../../services/customer_appCommonService";
import { useDispatch, useSelector } from "react-redux"; //useDispatch
import { InputField } from "../../../Components/formElements/InputField";
import { ComboboxField } from "../../../Components/formElements/ComboboxField";
import FailureModal from "../../../Components/Modal/supplier_app/FailureModal";
import {
  validateContactNumber,
  validateName,
  validateRequired,
  validPostalCode,
} from "../../../common/Validations";
import FileUploadComponent from "../../../Components/formElements/FileUploadComponent";
import Layout from "../../../Layout/Layout";
import FileViewerModal from "../../../Components/FileViewer/FileViewerModal";
import toast from "react-hot-toast";
import HRConstants from "../../../common/HRConstants";
import ItemServiceV2 from "../../../services/human_resource_appCommonService";
import { TextAreaField } from "../../../Components/formElements/TextAreaField";
import DataTable from "react-data-table-component";
import SupplierConstants from "../../../common/SupplierConstants";
import HeaderText from "../../../Components/Modal/supplier_app/PO_Collabration/HeaderText";
import HrProjectServices from "./HrProjectServices";
const message = {
  VALID_CUSTOMER_NAME: "Special characters or numbers are not allowed.",
  VALID_MAIL_ID: "Please enter a valid email address.",
  VALID_ALTERNATE_MAIL_ID: "Please enter a valid alternate email address.",
  VALID_CONTACT_NUMBER: "Please enter a valid contact number.",
  VALID_ALTERNATE_CONTACT_NUMBER:
    "Please enter a valid alternate contact number.",
  VALID_PURPOSE_JUSTIFICATION:
    "Please ensure the justification is under 500 characters.",
  VALID_POSTAL_CODE:
    "Enter a 6-character postal code with uppercase letters and numbers only",
  VALID_CONTACT_FIRST_NAME: "Special characters and numbers are not allowed",
  VALID_CONTACT_LAST_NAME: "Special characters and numbers are not allowed",
  VALID_BANK_ACC: "validate banck account number",
  EXIStS_MAIL_ID: "Email already exists",
  EXIStS_CONTACT_NUMBER: "Contact Number already exists",
  EXIStS_ALTERNATE_CONTACT_NUMBER: "Contact Number already exists",
  EXIStS_ALTERNATE_MAIL_ID: "Alternate Contact Number already exists",
  FILL_REQUIRED_FIELD: "Please fill the required field",
  ALTERNATE_MAIL_ID: "Email ID is same",
  ALTERNATE_CONTACT_NUMBER: "Contact number is same",
  GET_MAP_DISTANCE: "Please Click the Get Distance & Time button",
  DOC_NUMBER: "Invalid Document Number",
};
const HrProjectReg = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  localStorage.setItem("menu", "Client");
  localStorage.setItem("submenu", "Project");
  const appConfig = useSelector((state) => state?.app?.appConfig); // Application Details from Store
  let userData = useSelector((state) => state?.user?.data);
  let documentNumber = useSelector((state) => state?.hr?.employee?.employeeNr);
  /* pop failure modal */
  const failureModalData = {
    title: "Warning",
    ErrorMsg: "",
  };

  // eslint-disable-next-line
  const [isEditMode, setIsEditMode] = useState(false);
  const [getDropdownData, setDropdownData] = useState("");
  const [isCardVisible, setCardVisible] = useState(true);
  const [isCardVisible2, setCardVisible2] = useState(true);
  const [isCardVisible3, setCardVisible3] = useState(true);
  const [isCardVisible8, setCardVisible8] = useState(true);
  const [getFailureModal] = useState(failureModalData);
  const [getShowFailureModal, setShowFailureModal] = useState(false);
  // eslint-disable-next-line
  const [getErrorFields, setErrorFields] = useState([]);
  const [getTitle, setTitle] = useState([]);

  const [getLineItemHeaderTextModal, setLineItemHeaderTextModal] =
    useState(false);
  const [getHeaderTextIndex, setHeaderTextIndex] = useState(0);
  const [getDataToHeaderText, setDataToHeaderText] = useState([]);
  const [getServicesLineItemModal, setServicesLineItemModal] = useState(false);
  const [getServicesLineItemIndex, setServicesLineItemIndex] = useState(0);
  const [getServicesLineItemText, setServicesLineItemText] = useState([]);
  const [getServiceTitle, setServiceTitle] = useState("");
  const getDepartment = [
    {
      id: 1,
      code: "DEP001",
      name: "Human Resources",
      description: "Human Resources",
    },
    {
      id: 2,
      code: "DEP002",
      name: "Information Technology",
      description: "Information Technology",
    },
    { id: 3, code: "DEP003", name: "Finance", description: "Finance" },
    { id: 4, code: "DEP004", name: "Sales", description: "Sales" },
    { id: 5, code: "DEP005", name: "Marketing", description: "Marketing" },
    { id: 6, code: "DEP006", name: "Operations", description: "Operations" },
    { id: 7, code: "DEP007", name: "Procurement", description: "Procurement" },
    { id: 8, code: "DEP008", name: "Production", description: "Production" },
    {
      id: 9,
      code: "DEP009",
      name: "Quality Assurance",
      description: "Quality Assurance",
    },
    {
      id: 10,
      code: "DEP010",
      name: "Research & Development",
      description: "Research & Development",
    },
    {
      id: 11,
      code: "DEP011",
      name: "Administration",
      description: "Administration",
    },
    {
      id: 12,
      code: "DEP012",
      name: "Customer Support",
      description: "Customer Support",
    },
    { id: 13, code: "DEP013", name: "Legal", description: "Legal" },
    { id: 14, code: "DEP014", name: "Logistics", description: "Logistics" },
    { id: 15, code: "DEP015", name: "Maintenance", description: "Maintenance" },
  ];
  const getReportingPerson = [
    { id: 1, code: "EMP001", name: "John Smith", description: "John Smith" },
    {
      id: 2,
      code: "EMP002",
      name: "Sarah Johnson",
      description: "Sarah Johnson",
    },
    {
      id: 3,
      code: "EMP003",
      name: "Michael Brown",
      description: "Michael Brown",
    },
    { id: 4, code: "EMP004", name: "Emily Davis", description: "Emily Davis" },
  ];
  const [getReportingContactPerson, setReportingContactPerson] = useState([
    {
      id: Date.now(),
      contactTitle: "",
      department: "",
      reportingPerson: "",
      contactName: "",
      contactNumber: "",
      contactEmail: "",
    },
  ]);
  const addReportingContactPerson = () => {
    const newRow = {
      id: Date.now(),
      contactTitle: "",
      department: "",
      reportingPerson: "",
      contactName: "",
      contactNumber: "",
      contactEmail: "",
    };
    setReportingContactPerson((prevData) => [...prevData, newRow]);
  };
  const deleteReportingContactPerson = (id) => {
    const updatedData = getReportingContactPerson.filter(
      (doc) => doc.id !== id,
    );
    setReportingContactPerson(updatedData);
  };
  const handleChangeReportingContact = (id, fieldName, value) => {
    const errors = {};

    if (!validateRequired(value)) {
      errors[fieldName] = `${fieldName} is required.`;
    }

    if (fieldName === "contactNumber" && validateRequired(value)) {
      if (!validateContactNumber(value)) {
        errors[fieldName] = "Invalid contact number. Must be 10 digits.";
      }
    }

    setReportingContactPerson((prevData) =>
      prevData.map((doc) =>
        doc.id === id ? { ...doc, [fieldName]: value } : doc,
      ),
    );

    setValidation((prev) => ({
      ...prev,
      [`${id}_${fieldName}`]: errors[fieldName] || "",
    }));
  };
  const hideServicesLineItem = () => {
    setServicesLineItemModal(false);
  };
  const handleHeaderTextLineItemData = (data) => {
    setPhaseData((prevUsers) =>
      prevUsers.map((item) =>
        item.purchasingDocumentItemNr === getHeaderTextIndex
          ? { ...item, itemTextData: data }
          : item,
      ),
    );
  };
  const hideLineItemHeaderText = () => {
    setLineItemHeaderTextModal(false);
  };
  const showServicesLineItem = (index, data, type) => {
    setServicesLineItemModal(true);
    setServicesLineItemIndex(index);
    setServicesLineItemText(data);
    setServiceTitle(type === "SER" ? "Services List" : "Schedule List");
  };

  let POLineItemInitialData = [
    {
      local_id: 1,
      purchasingDocumentItemNr: 1,
      itemTextData: [],
      statusItem: "In Release",
      taxCode: 0,
      taxAmount: 0,
    },
  ];
  const showLineItemHeaderText = (index, data) => {
    setLineItemHeaderTextModal(true);
    setHeaderTextIndex(index);
    setDataToHeaderText(data);
  };
  useEffect(() => {
    if (getDropdownData?.code === "MAT") {
      // Material
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.code,
        [getDropdownData?.textDesc]: getDropdownData?.description,
      }));
      setProjectPhase(projectInitialCol);
      setPhaseData(POLineItemInitialData);
    } else {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.code,
        [getDropdownData?.textDesc]: getDropdownData?.description,
      }));
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getDropdownData]);

  let projectInitialCol = [
    {
      name: "Document Item Nr",
      selector: (row) => row.local_id || "--",
      sortable: true,
      width: "180px",
    },
    {
      name: "Item Text",
      selector: (row) => row.local_id || "--",
      sortable: true,
      width: "110px",
      cell: (row) => (
        <>
          <span
            style={{ marginLeft: "12px" }}
            onClick={() =>
              showLineItemHeaderText(row.local_id, row.itemTextData)
            }
          >
            <i className="bi bi-calendar2-week iconTable"></i>
          </span>
          <span className="suppliersIcon">
            {" "}
            {row.itemTextData?.length || 0}{" "}
          </span>
        </>
      ),
    },
    {
      name: "Material/Service ",
      selector: (row) => row.materialCode || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          // label="Please Enter the Remarks*"
          name="materialCode"
          placeholder=""
          value={row.materialCode || ""}
          onChange={(event) => handleInputChange(row.local_id, event)}
        />
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "Service",
      selector: (row) => row.local_id || "--",
      sortable: true,
      width: "110px",
      cell: (row) => (
        <>
          <span
            style={{ marginLeft: "12px" }}
            onClick={() =>
              showServicesLineItem(row.local_id, row.services, "SER")
            }
          >
            <i className="bi bi-calendar2-week iconTable"></i>
          </span>
          <span className="suppliersIcon"> {row.services?.length || 0} </span>
        </>
      ),
    },
    {
      name: "Description",
      selector: (row) => row.materialDescription || "--",
      cell: (row) => (
        <TextAreaField
          className="inputBox mt-1"
          name="materialDescription"
          placeholder=""
          value={row.materialDescription || ""}
          onChange={(event) => handleInputChange(row.local_id, event)}
        />
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "Material Group ",
      selector: (row) => row.materialGroup || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          // label="Please Enter the Remarks*"
          name="materialGroup"
          placeholder=""
          value={row.materialGroup || ""}
          onChange={(event) => handleInputChange(row.local_id, event)}
        />
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "Quantity ",
      selector: (row) => row.purchaseQuantity || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="purchaseQuantity"
          placeholder=""
          value={row.purchaseQuantity || ""}
          onChange={(event) => handleInputChange(row.local_id, event, "Number")}
        />
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "UOM ",
      selector: (row) => row.orderUnitOfMeasure || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="orderUnitOfMeasure"
          placeholder=""
          value={row.orderUnitOfMeasure || ""}
          onChange={(event) => handleInputChange(row.local_id, event)}
        />
      ),
      width: "200px",
    },
    {
      name: "Unit Price ",
      selector: (row) => row.orderPriceUnit || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          // label="Please Enter the Remarks*"
          name="orderPriceUnit"
          placeholder=""
          value={row.orderPriceUnit || ""}
          onChange={(event) => handleInputChange(row.local_id, event, "Number")}
        />
      ),
      width: "200px",
    },
    {
      name: "Item Value ",
      selector: (row) => row.netValue || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="netValue"
          placeholder=""
          value={row.netValue || 0}
          disabled={true}
        />
      ),
      width: "200px",
    },
    {
      name: "Currency ",
      selector: (row) => row.currencyCode || "INR",
      width: "200px",
    },
    {
      name: "Tax Amount",
      selector: (row) => row.taxAmount || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="taxAmount"
          placeholder=""
          value={row.taxAmount || 0}
          disabled={true}
        />
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "Tax Code % ",
      selector: (row) => row.taxCode || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="taxCode"
          placeholder=""
          value={row.taxCode}
          onChange={(event) =>
            handleInputChange(row.local_id, event, "Number", "VAT")
          }
        />
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "Delivery Date",
      selector: (row) => row.deliveryDate || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          type="date"
          name="deliveryDate"
          placeholder=""
          value={row.deliveryDate || ""}
          onChange={(event) => handleInputChange(row.local_id, event)}
        />
      ),
      width: "200px",
    },
    {
      name: "Plant",
      selector: (row) => row.plant || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          // label="Please Enter the Remarks*"
          name="plant"
          placeholder=""
          value={row.plant || ""}
          onChange={(event) => handleInputChange(row.local_id, event)}
        />
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "Storage Location",
      selector: (row) => row.storageLocn || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          // label="Please Enter the Remarks*"
          name="storageLocn"
          placeholder=""
          value={row.storageLocn || ""}
          onChange={(event) => handleInputChange(row.local_id, event)}
        />
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "Delete",
      selector: (row) => row.local_id || "--",
      sortable: true,
      cell: (row) => (
        <button
          className="btn btn-danger"
          // onClick={() => removePOItemRow(row.local_id)}
        >
          <i className="bi bi-trash3"></i>
        </button>
      ),
      width: "120px",
    },
  ];
  const predefinedPhases = [
    {
      phaseName: "Project Preparation",
      description: "Initial project planning, scope, and team setup.",
    },
    {
      phaseName: "Business Blueprint",
      description: "Document business requirements and processes.",
    },
    {
      phaseName: "Realization",
      description: "Configure and build the solution based on blueprint.",
    },
    {
      phaseName: "Final Preparation",
      description: "Testing, training, and cutover preparation.",
    },
    {
      phaseName: "Go-Live and Support",
      description: "Go-live and post go-live support.",
    },
  ];
  const addProjectPhase = () => {
    setPhaseData((prevData) => {
      const nextPhaseNumber = prevData.length + 1;

      // Phase 1 to Phase 5
      if (nextPhaseNumber <= 5) {
        const phaseData = predefinedPhases[nextPhaseNumber - 1];

        return [
          ...prevData,
          {
            local_id: Date.now(),
            phaseNr: `Phase ${nextPhaseNumber}`,
            phaseName: phaseData.phaseName,
            description: phaseData.description,
            services: [],
            status: "Not Started",
            isCustomPhase: false,
          },
        ];
      }

      // After Phase 5 - Custom Phase
      return [
        ...prevData,
        {
          local_id: Date.now(),
          phaseNr: `Phase ${nextPhaseNumber}`,
          phaseName: "",
          description: "",
          services: [],
          status: "Not Started",
          isCustomPhase: true,
        },
      ];
    });
  };
  const ProjectPhasesInitialData = [
    {
      local_id: 1,
      phaseNr: "Phase 1",
      phaseName: "Project Preparation",
      description: "Initial project planning, scope, and team setup.",
      services: [],
      status: "Not Started",
      isCustomPhase: false,
    },
  ];
  // const handlePhases = (data) => {
  //   setPhaseData((prevPhases) =>
  //     prevPhases.map((item) =>
  //       item.local_id === getServicesLineItemIndex
  //         ? { ...item, services: data }
  //         : item,
  //     ),
  //   );
  // };
  const handlePhases = (data) => {
    const servicesWithTaskId = (data || []).map((service, index) => ({
      ...service,
      taskID: `TID${String(index + 1).padStart(2, "0")}`,
    }));

    setPhaseData((prevPhases) =>
      prevPhases.map((item) =>
        item.local_id === getServicesLineItemIndex
          ? {
              ...item,
              services: servicesWithTaskId,
            }
          : item,
      ),
    );
  };
  const [getPhaseData, setPhaseData] = useState(ProjectPhasesInitialData);
  const handlePhaseInputChange = (id, event) => {
    const { name, value } = event.target;
    setPhaseData((prevData) =>
      prevData.map((item) =>
        item.local_id === id
          ? {
              ...item,
              [name]: value,
            }
          : item,
      ),
    );
  };
  let ProjectPhaseCol = [
    {
      name: "Phase",
      selector: (row) => row.phaseNr || "--",
      sortable: true,
      width: "110px",
    },

    {
      name: "Phase Name",
      selector: (row) => row.phaseName || "--",

      cell: (row) =>
        row.isCustomPhase ? (
          <InputField
            className="inputBox mt-1"
            name="phaseName"
            placeholder="Enter Phase Name"
            value={row.phaseName || ""}
            onChange={(event) => handlePhaseInputChange(row.local_id, event)}
          />
        ) : (
          <span>{row.phaseName || "--"}</span>
        ),

      sortable: true,
      width: "220px",
    },

    {
      name: "Description",
      selector: (row) => row.description || "--",

      cell: (row) => (
        <TextAreaField
          className="inputBox mt-1"
          name="description"
          placeholder="Enter Description"
          value={row.description || ""}
          onChange={(event) => handlePhaseInputChange(row.local_id, event)}
        />
      ),

      width: "300px",
    },

    {
      name: "Services",
      selector: (row) => row.local_id || "--",
      width: "150px",

      cell: (row) => (
        <>
          <span
            style={{ marginLeft: "12px", cursor: "pointer" }}
            onClick={() =>
              showServicesLineItem(row.local_id, row.services, "SER")
            }
          >
            <i className="bi bi-calendar2-week iconTable"></i>
          </span>

          <span className="suppliersIcon">{row.services?.length || 0}</span>
        </>
      ),
    },
  ];

  const [getProjectPhase, setProjectPhase] = useState(ProjectPhaseCol);

  useEffect(() => {
    if (getDropdownData?.codeType === "title") {
      setReportingContactPerson((prev) =>
        prev.map((doc) =>
          doc.id === getDropdownData?.index
            ? {
                ...doc,
                [getDropdownData.textField]: getDropdownData.name,
                [getDropdownData.textCode]: getDropdownData.code,
                [getDropdownData.textDesc]: getDropdownData.description,
              }
            : doc,
        ),
      );
    } else if (getDropdownData?.codeType === "department") {
      setReportingContactPerson((prev) =>
        prev.map((doc) =>
          doc.id === getDropdownData?.index
            ? {
                ...doc,
                [getDropdownData.textField]: getDropdownData.name,
                [getDropdownData.textCode]: getDropdownData.code,
                [getDropdownData.textDesc]: getDropdownData.description,
              }
            : doc,
        ),
      );
    } else if (getDropdownData?.codeType === "reportingPerson") {
      setReportingContactPerson((prev) =>
        prev.map((doc) =>
          doc.id === getDropdownData?.index
            ? {
                ...doc,
                [getDropdownData.textField]: getDropdownData.name,
                [getDropdownData.textCode]: getDropdownData.code,
                [getDropdownData.textDesc]: getDropdownData.description,
              }
            : doc,
        ),
      );
    } else if (getDropdownData?.textCode === "proDesignationCode") {
      setFormInputs((prev) => ({
        ...prev,
        [getDropdownData.textField]: getDropdownData.name,
        [getDropdownData.textCode]: getDropdownData.code,
        [getDropdownData.textDesc]: getDropdownData.description,
      }));
    }

    setValidation((prev) => ({
      ...prev,
      [getDropdownData?.textField]: "",
    }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getDropdownData]);
  const [getcustomerContactPerson, setcustomerContactPerson] = useState([
    {
      id: Date.now(),
      contactPosition: "",
      contactTitle: "",
      contactName: "",
      contactNumber: "",
      contactEmail: "",
    },
  ]);
  const [getDocumentTypeData, setDocumentTypeData] = useState([
    {
      id: Date.now(),
      name: "Document 1",
      documentType: "",
      documentNumber: "",
      issueDate: "",
      issuingAuthority: "",
      certificateCode: "29AADCN1012B1Z6",
    },
  ]);

  const [getdocumentType, setdocumentType] = useState([]);
  const [getState, setState] = useState([]);
  const [getCountry, setCountry] = useState([]);
  const [getShowFileViewModal, setShowFileViewModal] = useState(false);
  const [getFileViewData, setFileViewData] = useState(null);
  const [validation, setValidation] = useState({
    employeeName: "",
    routeNumber: "",
    commission: "Yes",
    commissionRate: "",
  });

  //bank state
  const [getBankDetails, setBankDetails] = useState([]);
  const toggleCardVisibility = () => {
    setCardVisible(!isCardVisible);
  };
  const toggleCardVisibility2 = () => {
    setCardVisible2(!isCardVisible2);
  };
  const toggleCardVisibility3 = () => {
    setCardVisible3(!isCardVisible3);
  };

  const toggleCardVisibility8 = () => {
    setCardVisible8(!isCardVisible8);
  };
  const onInputChange = ({ target: { name, value } }) => {
    const errors = {};
    setFormInputs((formInputs) => ({ ...formInputs, [name]: value }));
    // console.log("onInputChange => formInputs", formInputs);
    validateName(name === "employeeName" ? value : "")
      ? (errors.employeeName = "")
      : (errors.employeeName = message.VALID_CUSTOMER_NAME);
    validPostalCode(name === "cityPostalCode" ? value : "")
      ? (errors.cityPostalCode = "")
      : (errors.cityPostalCode = message.VALID_POSTAL_CODE);

    setValidation((prev) => ({
      ...prev,
      [name]: errors[name] || "",
    }));
  };

  const [formInputs, setFormInputs] = useState({
    createdBy: userData?.userId || "",
    resignationDate: "",
    relievingDate: "",
    hrDocType: "",
    hrDocTypeCode: "",
    hrDocTypeDesc: "",
    employeeName: "",
    address: "",
    address2: "",
    city: "",
    country: "IN - India",
    state: "IN - Karnataka",
    cityPostalCode: "",
    companyCode: "",

    version: "v0",
    status: "Registered",
    category: "VENDOR",

    routeNumber: "",
    commission: "Yes",
    commissionRate: "",
    salesOfficerCode: "",
    salesOfficerName: "",

    plantAddress: appConfig?.customerPlantAddress,
    projectLocation: "",

    customerTypeCode: "C03",
    customerTypeDesc: "Domestic",

    jobRole: "",
    otherJobRole: "",
  });
  // eslint-disable-next-line
  const [disabled, setDisabled] = useState(false);
  // console.log(">>formInputs", formInputs);
  useEffect(() => {
    // dispatch(getSupplierCategorySelection()); // getSupplierCategorySelection store
    getMasterData();
  }, [dispatch]);

  useEffect(() => {
    if (getDropdownData?.codeType === "country") {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.code,
        [getDropdownData?.textDesc]: getDropdownData?.description,
      }));
      getStateData(getDropdownData?.code);
    } else if (getDropdownData?.codeType === "companyCode") {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.code,
        [getDropdownData?.textDesc]: getDropdownData?.description,
      }));
      // getStateData(getDropdownData?.code);
    } else if (getDropdownData?.textCode === "salesOfficerCode") {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.code,
        [getDropdownData?.textDesc]: getDropdownData?.description,
      }));
    } else if (getDropdownData?.codeType === "jobtitle") {
      setcustomerContactPerson((prev) =>
        prev.map((doc) =>
          doc.id === getDropdownData?.index
            ? {
                ...doc,
                [getDropdownData?.textField]: getDropdownData?.name,
                [getDropdownData?.textCode]: getDropdownData?.code,
                [getDropdownData?.textDesc]: getDropdownData?.description,
              }
            : doc,
        ),
      );
    } else if (getDropdownData?.codeType === "title") {
      setcustomerContactPerson((prev) =>
        prev.map((doc) =>
          doc.id === getDropdownData?.index
            ? {
                ...doc,
                [getDropdownData?.textField]: getDropdownData?.name,
                [getDropdownData?.textCode]: getDropdownData?.code,
                [getDropdownData?.textDesc]: getDropdownData?.description,
              }
            : doc,
        ),
      );
    } else if (getDropdownData?.codeType === "documentType") {
      setDocumentTypeData((prev) =>
        prev.map((doc) =>
          doc.id === getDropdownData?.index
            ? {
                ...doc,
                [getDropdownData?.textField]: getDropdownData?.name,
                [getDropdownData?.textCode]: getDropdownData?.code,
                [getDropdownData?.textDesc]: getDropdownData?.description,
              }
            : doc,
        ),
      );
    } else if (getDropdownData?.codeType === "department") {
      setcustomerContactPerson((prev) =>
        prev.map((doc) =>
          doc.id === getDropdownData?.index
            ? {
                ...doc,
                [getDropdownData.textField]: getDropdownData.name,
                [getDropdownData.textCode]: getDropdownData.code,
                [getDropdownData.textDesc]: getDropdownData.description,
              }
            : doc,
        ),
      );
    } else if (getDropdownData?.codeType === "reportingPerson") {
      setReportingContactPerson((prev) =>
        prev.map((doc) =>
          doc.id === getDropdownData?.index
            ? {
                ...doc,
                [getDropdownData.textField]: getDropdownData.name,
                [getDropdownData.textCode]: getDropdownData.code,
                [getDropdownData.textDesc]: getDropdownData.description,
              }
            : doc,
        ),
      );
    }

    setValidation((prev) => ({
      ...prev,
      [getDropdownData?.textField]: "",
    }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getDropdownData]);

  useEffect(() => {
    if (getDropdownData?.textCode === "jobRoleCode") {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.code,
        [getDropdownData?.textDesc]: getDropdownData?.description,
      }));
    }

    // Other conditions remain unchanged...

    setValidation((prev) => ({
      ...prev,
      [getDropdownData?.textField]: "",
    }));
  }, [getDropdownData]);

  const loadFirstLevelData1 = async (page) => {
    if (documentNumber !== "") {
      let obj = {
        documentNumber: documentNumber,
      };
      const toastId = toast.loading("Loading...", {
        position: "top-right",
      });
      await ItemService.getCustomerDetail(obj).then((item) => {
        // console.log(">> res!", item);
        if (item?.status === 200) {
          setFormInputs(item?.data[0]);
          setReportingContactPerson(item?.data[0]?.reportingDetails || []);

          setcustomerContactPerson(item?.data[0]?.contactDetails || []);
          setBankDetails(item?.data[0]?.bandkDetails || []);
          setDocumentTypeData(item?.data[0]?.certifications || []);
        } else {
          toast.error(item?.message || "Please try again !!", {
            duration: 4000,
            position: "top-right",
          });
        }
        toast.dismiss(toastId);
      });
      // setLoading(false);
    }
    // else {
    // if (JSON.stringify(workflow) === "{}") {
    //   if (workflow?.page === "Inbox") {
    //     navigate(Constants.INBOX);
    //   } else {
    //     navigate(Constants.OUTBOX);
    //   }
    // }
    //   else {
    //     navigate(CustomerConstants.CUSTOMER_V3_CUSTOMER_LIST);
    //   }
    // }
  };

  useEffect(() => {
    loadFirstLevelData1();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //Load Master Data
  const getMasterData = async () => {
    let obj = {
      codeType: "title",
    };
    await ItemService.getMasterDataSelf(obj).then((item) => {
      // console.log(">> item! title", item);
      if (item?.status === 200) {
        setTitle(item?.data);
      } else {
        setTitle([]);
        console.log(">> Error: Loading getMasterDataSelf");
      }
    });

    let obj1 = {
      codeType: "documentType",
    };
    await ItemService.getMasterDataSelf(obj1).then((item) => {
      // console.log('>> item!',item);
      if (item?.status === 200) {
        setdocumentType(item?.data);
      } else {
        setdocumentType([]);
        console.log(">> Error: Loading getMasterData");
      }
    });
    let obj3 = {
      codeType: "country",
    };
    await ItemService.getMasterDataSelf(obj3).then((item) => {
      // console.log('>> item!',item);
      if (item?.status === 200) {
        setCountry(item?.data);
      } else {
        setCountry([]);
        console.log(">> Error: Loading getMasterDataSelf");
      }
    });
  };
  // Onselect of Country state will load
  const getStateData = async (code) => {
    let obj1 = {
      codeType: "region",
      code: code,
    };
    await ItemService.getMasterDataSelf(obj1).then((item) => {
      // console.log('>> item!',item);
      if (item?.status === 200) {
        setState(item?.data);
      } else {
        setState([]);
        console.log(">> Error: Loading getMasterDataSelf");
      }
    });
  };

  const hideFailureModal = () => {
    setShowFailureModal(false);
  };

  /* ---------------------Customer Contact Person -------- */
  // eslint-disable-next-line
  const addCustomerCantactPerson = () => {
    const newDocument = {
      id: Date.now(),
      contactPosition: "",
      contactTitle: "",
      contactName: "",
      contactNumber: "",
      contactEmail: "",
    };
    setcustomerContactPerson((prevData) => [...prevData, newDocument]);
  };
  /* ---------------------Document Type  03rd block-------- */

  const deleteDocumentType = (id) => {
    const updatedData1 = getDocumentTypeData.filter((doc) => doc.id !== id);
    setDocumentTypeData(updatedData1);
  };
  // eslint-disable-next-line
  const addDocumentType = () => {
    const newDocument = {
      id: Date.now(),
      name: `Document ${getDocumentTypeData.length + 1}`,
      documentType: "",
      documentNumber: "",
      issueDate: "",
      issuingAuthority: "",
      certificateCode: "",
    };
    setDocumentTypeData((prevData) => [...prevData, newDocument]);
  };
  const handleInputChange = (id, fieldName, value) => {
    const errors = {};

    setDocumentTypeData((prevData) =>
      prevData.map((doc) =>
        doc.id === id ? { ...doc, [fieldName]: value } : doc,
      ),
    );

    setValidation((prev) => ({
      ...prev,
      [`${id}_${fieldName}`]: errors[fieldName] || "",
    }));
  };

  const onSuccessUploadDocumentType = (data) => {
    setDocumentTypeData((prevData) =>
      prevData.map((doc) =>
        doc.id === data.fieldId
          ? { ...doc, [data.fieldName]: data.attachmentId }
          : doc,
      ),
    );
  };

  // View attachment files
  const handleViewFile = (fileAttachmentId) => {
    setFileViewData(fileAttachmentId);
    setShowFileViewModal(true);
  };
  const handleViewFileHide = () => {
    setShowFileViewModal(false);
  };

  //bank start

  const bankInfoInitialData = {
    id: "",
    bankNotListed: "",
    bankAccountNumber: "",
    bankKey: "",
    bankName: "",
    bankCountry: "",
    bankAddress: "",
    AccountHolderName: "",
    bankCompanyletterhead: "",
    bankConfirmationLetter: "",
    chipsCode: "",
    swiftIfscCode: "",
    bankInfoTemplate: "",
    preferredCurrency: "",
  };
  useEffect(() => {
    setBankDetails([...getBankDetails, bankInfoInitialData]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const handleSave = async () => {
    const projectPhase = {};
    getPhaseData.forEach((phase, index) => {
      let phaseKey = "";

      if (index < 5 && !phase.isCustomPhase) {
        phaseKey = `phase${index + 1}`;
      } else {
        phaseKey = phase.phaseName?.trim() || `phase${index + 1}`;
      }

      projectPhase[phaseKey] = phase.services || [];
    });

    formInputs.firstName = formInputs.employeeName;
    formInputs.contactDetails = getcustomerContactPerson;
    formInputs.reportingDetails = getReportingContactPerson;
    formInputs.certifications = getDocumentTypeData;
    formInputs.bandkDetails = getBankDetails;
    formInputs.organisationName = formInputs.employeeName;
    formInputs.projectPhase = projectPhase;

    const obj = {
      data: formInputs,
      type: "Save",
    };
    setDisabled(true);
    await ItemServiceV2.addProject(obj).then((item) => {
      if (item?.status === 200) {
        toast.success(item?.message || "added successfully", {
          duration: 2000,
          position: "top-right",
        });

        navigate(HRConstants.HR_PROJECT_LIST);
      } else {
        toast.error(item?.message || "Please try again !!", {
          duration: 4000,
          position: "top-right",
        });
      }

      setDisabled(false);
    });
  };
  const handleDraft = async () => {
    let obj = {
      data: formInputs,
      type: "Draft",
    };
    await ItemServiceV2.addProject(obj).then((item) => {
      if (item?.status === 200) {
        toast.success(item?.message || "added successfully", {
          duration: 8000,
          position: "top-right",
        });
        navigate(HRConstants.HR_PROJECT_LIST);
      } else {
        toast.error(item?.message || "Please try again !!", {
          duration: 4000,
          position: "top-right",
        });
      }
      setDisabled(false);
    });
  };

  const handleSubmit = async (type) => {
    if (type === "Save") {
      await handleSave(type);
    } else if (type === "Draft") {
      await handleDraft(type);
    }
  };

  return (
    <main className="dashboard main sri-venkateshwara" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner PageCommonCSS">
            <h2 className="mainTitle">Project Creation</h2>
            <hr />
            {/* customer details */}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible ? "bi-chevron-right" : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">E</span>
                    </Col>
                    <Col xs={8} md={8} lg={8}>
                      <span className="headerTitle">Client </span>
                      <span className="subHeaderTitle">Client Details</span>
                    </Col>
                  </Row>
                </h2>
                <div
                  className={`accordion-collapse collapse show ${
                    isCardVisible ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body">
                    <Row className="pt-2 pb-4">
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          // label="Employee Name"
                          label={
                            <>
                              <i className="bi bi-person labelIcon"></i>
                              Client Name
                            </>
                          }
                          name="clientName"
                          placeholder=""
                          value={formInputs.clientName || ""}
                          onChange={onInputChange}
                          required={true}
                          error={validation.clientName}
                          // disabled={true}
                          disabled={!isEditMode}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          // label="Mobile Nr"
                          label={
                            <>
                              <i className="bi bi-telephone labelIcon"></i>
                              Mobile Nr
                            </>
                          }
                          name="mobileNr"
                          placeholder=""
                          value={formInputs.mobileNr || ""}
                          onChange={onInputChange}
                          error={validation.mobileNr}
                          // disabled={true}
                          disabled={!isEditMode}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          // label=" Address Lines 1 / Street"
                          label={
                            <>
                              <i className="bi bi-geo-alt labelIcon"></i>
                              Address Lines 1 / Street
                            </>
                          }
                          name="address"
                          placeholder=""
                          value={formInputs.address || ""}
                          onChange={onInputChange}
                          error={validation.address}
                          required={true}
                          // disabled={true}
                          disabled={!isEditMode}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          // label="Address Line 2"
                          label={
                            <>
                              <i className="bi bi-signpost-2 labelIcon"></i>
                              Address Line 2
                            </>
                          }
                          name="address2"
                          placeholder=""
                          value={formInputs.address2 || ""}
                          onChange={onInputChange}
                          error={validation.address2}
                          required={true}
                          // disabled={true}
                          disabled={!isEditMode}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          // label="City"
                          label={
                            <>
                              <i className="bi bi-buildings labelIcon"></i>
                              City
                            </>
                          }
                          name="city"
                          placeholder=""
                          value={formInputs.city || ""}
                          onChange={onInputChange}
                          error={validation.city}
                          required={true}
                          // disabled={true}
                          disabled={!isEditMode}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <ComboboxField
                          // label="Country"
                          label={
                            <>
                              <i className="bi bi-globe-asia-australia labelIcon"></i>
                              Country
                            </>
                          }
                          placeholder=""
                          data={getCountry}
                          id="country"
                          iconClassName="dropdownIcon"
                          name="country"
                          code="countryCode"
                          description="countryDesc"
                          setValue={formInputs.country}
                          getvalue={setDropdownData}
                          required={true}
                          // disabled={true}
                          disabled={!isEditMode}
                          // error={validation.country}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <ComboboxField
                          // label="State"
                          label={
                            <>
                              <i className="bi bi-map labelIcon"></i>
                              State
                            </>
                          }
                          placeholder=""
                          data={getState}
                          id="state"
                          iconClassName="dropdownIcon"
                          name="state"
                          code="stateCode"
                          description="stateDesc"
                          setValue={formInputs.state}
                          getvalue={setDropdownData}
                          required={true}
                          // disabled={true}
                          disabled={!isEditMode}
                          // error={validation.state}
                        />
                      </Col>

                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          // label="Postal Code/PO Box"
                          label={
                            <>
                              <i className="bi bi-mailbox labelIcon"></i>
                              Postal Code / PO Box
                            </>
                          }
                          name="cityPostalCode"
                          placeholder=""
                          value={formInputs.cityPostalCode}
                          onChange={onInputChange}
                          error={validation.cityPostalCode}
                          required={true}
                          // disabled={true}
                          disabled={!isEditMode}
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
            {/*Reporting person*/}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible2
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility2}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">RP</span>
                    </Col>
                    <Col xs={4} md={8} lg={8}>
                      <span className="headerTitle">Reporting Details</span>
                      <span className="subHeaderTitle">Reporting Details</span>
                    </Col>
                    <Col xs={4} md={2} lg={2}>
                      <div className="d-flex justify-content-end  p-2 me-3">
                        <button
                          className="btnTable"
                          onClick={addReportingContactPerson}
                        >
                          <i className="bi bi-plus-lg"></i> Add
                        </button>
                      </div>
                    </Col>
                  </Row>
                </h2>
                <div
                  className={`accordion-collapse collapse show ${
                    isCardVisible2 ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body">
                    <Row className="pt-4 d-none d-lg-flex">
                      <Col xs={12} md={2} lg={2}>
                        <p className="fs-6 fw-medium d-flex ms-4">
                          <i className="bi bi-person-badge labelIcon"></i>
                          Contact Title
                        </p>
                      </Col>

                      <Col xs={12} md={2} lg={2}>
                        <p className="fs-6 fw-medium d-flex ms-4">
                          <i className="bi bi-building labelIcon"></i>
                          Department
                        </p>
                      </Col>

                      <Col xs={12} md={2} lg={2}>
                        <p className="fs-6 fw-medium d-flex ms-4">
                          <i className="bi bi-person-check labelIcon"></i>
                          Reporting Person
                        </p>
                      </Col>

                      <Col xs={12} md={2} lg={2}>
                        <p className="fs-6 fw-medium d-flex ms-4">
                          <i className="bi bi-person labelIcon"></i>
                          Contact Person
                        </p>
                      </Col>

                      <Col xs={12} md={2} lg={2}>
                        <p className="fs-6 fw-medium d-flex ms-4">
                          <i className="bi bi-telephone labelIcon"></i>
                          Contact Number
                        </p>
                      </Col>

                      <Col xs={12} md={1} lg={1}>
                        <p className="fs-6 fw-medium d-flex ms-4">
                          <i className="bi bi-envelope labelIcon"></i>
                          Email-ID
                        </p>
                      </Col>

                      <Col xs={12} md={1} lg={1}>
                        <p className="fs-6 fw-medium d-flex">
                          <i className="bi bi-gear labelIcon"></i>
                          Action
                        </p>
                      </Col>
                    </Row>
                    {getReportingContactPerson.map((doc, index) => (
                      <Row key={doc.id}>
                        <Col xs={12}>
                          <hr className="mx-4 my-0 text-color-black" />
                        </Col>
                        <Col
                          xs={12}
                          md={2}
                          lg={2}
                          className="commTopButtonRightLeftPadding"
                        >
                          <ComboboxField
                            label=""
                            placeholder="Contact Title"
                            data={getTitle}
                            id="contactTitle"
                            iconClassName="dropdownIcon"
                            name="contactTitle"
                            code="contactTitleCode"
                            description="contactTitleDesc"
                            setValue={doc?.contactTitle}
                            getvalue={setDropdownData}
                            index={doc.id}
                            onChangeValue={handleChangeReportingContact}
                            disabled={true}
                          />
                        </Col>

                        <Col
                          xs={12}
                          md={2}
                          lg={2}
                          className="commTopButtonRightLeftPadding"
                        >
                          <ComboboxField
                            label=""
                            placeholder="Department"
                            data={getDepartment}
                            id="department"
                            iconClassName="dropdownIcon"
                            name="department"
                            code="departmentCode"
                            description="departmentDesc"
                            setValue={doc?.department}
                            getvalue={setDropdownData}
                            index={doc.id}
                            onChangeValue={handleChangeReportingContact}
                            disabled={true}
                          />
                        </Col>

                        <Col
                          xs={12}
                          md={2}
                          lg={2}
                          className="commTopButtonRightLeftPadding"
                        >
                          <ComboboxField
                            label=""
                            placeholder="Reporting Person"
                            data={getReportingPerson}
                            id="reportingPerson"
                            iconClassName="dropdownIcon"
                            name="reportingPerson"
                            code="reportingPersonCode"
                            description="reportingPersonDesc"
                            setValue={doc?.reportingPerson}
                            getvalue={setDropdownData}
                            index={doc.id}
                            onChangeValue={handleChangeReportingContact}
                            disabled={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={2}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox mt-1"
                            name="contactName"
                            placeholder="Contact Person"
                            value={doc.contactName || ""}
                            onChange={(e) =>
                              handleChangeReportingContact(
                                doc.id,
                                "contactName",
                                e.target.value,
                              )
                            }
                            error={validation[`${doc.id}_contactName`]}
                            disabled={true}
                          />
                        </Col>

                        <Col
                          xs={12}
                          md={4}
                          lg={2}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox mt-1"
                            name="contactNumber"
                            placeholder="Contact Number"
                            value={doc.contactNumber || ""}
                            onChange={(e) =>
                              handleChangeReportingContact(
                                doc.id,
                                "contactNumber",
                                e.target.value,
                              )
                            }
                            error={validation[`${doc.id}_contactNumber`]}
                            disabled={true}
                          />
                        </Col>

                        <Col
                          xs={12}
                          md={4}
                          lg={1}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox mt-1"
                            name="contactEmail"
                            placeholder="Email"
                            value={doc.contactEmail || ""}
                            onChange={(e) =>
                              handleChangeReportingContact(
                                doc.id,
                                "contactEmail",
                                e.target.value,
                              )
                            }
                            error={validation[`${doc.id}_contactEmail`]}
                            disabled={true}
                          />
                        </Col>

                        <Col
                          xs={12}
                          md={4}
                          lg={1}
                          className="commTopButtonRightLeftPadding"
                        >
                          <i
                            onClick={() => deleteReportingContactPerson(doc.id)}
                            className="bi bi-trash text-danger fs-4"
                          />
                        </Col>
                      </Row>
                    ))}
                  </div>
                </div>
              </div>
            </div>
            {/* customer Doucment Type */}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible3
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility3}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">DT</span>
                    </Col>
                    <Col xs={4} md={8} lg={8}>
                      <span className="headerTitle"> Doucment Type</span>
                      <span className="subHeaderTitle">Doucment Type</span>
                    </Col>
                  </Row>
                </h2>
                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${
                    isCardVisible3 ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body">
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <div className="accordion-body">
                          <div className="d-flex-column justify-content-center">
                            <Row>
                              <Col xs={12}>
                                <div className="accordion-body">
                                  <div className="d-flex-column justify-content-center">
                                    <Row className="pt-4 d-none d-lg-flex">
                                      <Col xs={12} md={4} lg={2}>
                                        <p className="fs-6 fw-medium d-flex ms-4">
                                          <i className="bi bi-file-earmark-text labelIcon"></i>
                                          Document Type
                                        </p>
                                      </Col>

                                      <Col xs={12} md={4} lg={2}>
                                        <p className="fs-6 fw-medium d-flex ms-4">
                                          <i className="bi bi-upc-scan labelIcon"></i>
                                          Document Number
                                        </p>
                                      </Col>

                                      <Col xs={12} md={4} lg={2}>
                                        <p className="fs-6 fw-medium d-flex ms-4">
                                          <i className="bi bi-calendar-check labelIcon"></i>
                                          Issue Date
                                        </p>
                                      </Col>

                                      <Col xs={12} md={4} lg={1}>
                                        <p className="fs-6 fw-medium d-flex ms-4">
                                          <i className="bi bi-eye labelIcon"></i>
                                          View Files
                                        </p>
                                      </Col>

                                      <Col xs={12} md={4} lg={2}>
                                        <p className="fs-6 fw-medium d-flex ms-4">
                                          <i className="bi bi-paperclip labelIcon"></i>
                                          Attachments
                                        </p>
                                      </Col>

                                      <Col xs={12} md={4} lg={2}>
                                        <p className="fs-6 fw-medium d-flex justify-content-center ms-4">
                                          <i className="bi bi-gear labelIcon"></i>
                                          Action
                                        </p>
                                      </Col>
                                    </Row>
                                    {getDocumentTypeData.map((doc, index) => (
                                      <Row key={doc.id}>
                                        <Col xs={12}>
                                          <hr className="mx-4 my-0 text-color-black" />
                                        </Col>
                                        <Col
                                          xs={12}
                                          md={4}
                                          lg={2}
                                          className="commTopButtonRightLeftPadding"
                                        >
                                          <ComboboxField
                                            label=""
                                            placeholder="Document type"
                                            data={getdocumentType}
                                            id="documentType"
                                            iconClassName="dropdownIcon"
                                            name="documentType"
                                            code="documentTypeCode"
                                            description="documentTypeDesc"
                                            setValue={doc?.documentType}
                                            getvalue={setDropdownData}
                                            index={doc.id}
                                            onChangeValue={handleInputChange}
                                            // disabled={true}
                                            disabled={!isEditMode}
                                          />
                                        </Col>
                                        <Col
                                          xs={12}
                                          md={4}
                                          lg={2}
                                          className="commTopButtonRightLeftPadding"
                                        >
                                          <InputField
                                            className="inputBox"
                                            placeholder="Document Number"
                                            value={doc.documentNumber}
                                            onChange={(e) =>
                                              handleInputChange(
                                                doc.id,
                                                "documentNumber",
                                                e.target.value,
                                              )
                                            }
                                            error={
                                              validation[
                                                `${doc.id}_documentNumber`
                                              ]
                                            }
                                            // disabled={true}
                                            disabled={!isEditMode}
                                          />
                                        </Col>
                                        <Col
                                          xs={12}
                                          md={4}
                                          lg={2}
                                          className="commTopButtonRightLeftPadding"
                                        >
                                          <InputField
                                            className="inputBox"
                                            type="date"
                                            value={doc.issueDate}
                                            onChange={(e) =>
                                              handleInputChange(
                                                doc.id,
                                                "issueDate",
                                                e.target.value,
                                              )
                                            }
                                            // disabled={true}
                                            disabled={!isEditMode}
                                          />
                                        </Col>
                                        <Col
                                          xs={12}
                                          md={4}
                                          lg={1}
                                          className="commTopButtonRightLeftPadding"
                                        >
                                          <div className="d-flex justify-content-center">
                                            {(doc.iSOCertification && (
                                              <img
                                                src="assets/img/newIcons/attached-file.png"
                                                className="mt-1 attachmentIcon"
                                                alt="attachments"
                                                onClick={() =>
                                                  handleViewFile(
                                                    doc.iSOCertification,
                                                  )
                                                }
                                              />
                                            )) ||
                                              "--"}
                                          </div>
                                        </Col>
                                        <Col
                                          xs={12}
                                          md={4}
                                          lg={3}
                                          className="commTopButtonRightLeftPadding"
                                        >
                                          <FileUploadComponent
                                            id={doc.id}
                                            name="iSOCertification"
                                            label=""
                                            allowedTypes={[
                                              "image/png",
                                              "image/jpeg",
                                              "application/pdf",
                                            ]}
                                            multiple={true} // Change to `false` for single file selection
                                            required={true}
                                            onSuccessUpload={
                                              onSuccessUploadDocumentType
                                            }
                                            value={doc.iSOCertification || ""}
                                          />
                                        </Col>
                                        <Col
                                          xs={12}
                                          md={4}
                                          lg={1}
                                          className="commTopButtonRightLeftPadding"
                                        >
                                          <i
                                            onClick={() =>
                                              deleteDocumentType(doc.id)
                                            }
                                            className="bi bi-trash text-danger fs-4"
                                          />
                                        </Col>
                                      </Row>
                                    ))}
                                  </div>
                                </div>
                              </Col>
                            </Row>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
            {/* Project Details */}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible8
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility8}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">PH</span>
                    </Col>
                    <Col xs={12} md={3} lg={3}>
                      <span className="headerTitle">Project Phases</span>
                      <span className="subHeaderTitle">Project Phases</span>
                    </Col>
                    <Col xs={12} md={8} lg={8} className="headerButtonAlign">
                      <div className="d-flex justify-content-end">
                        <button
                          type="button"
                          className="btnTable"
                          onClick={addProjectPhase}
                        >
                          <i className="bi bi-plus-lg"></i> Add Phase
                        </button>
                      </div>
                    </Col>
                  </Row>
                </h2>
                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${
                    isCardVisible8 ? "visible" : ""
                  }`}
                  // aria-labelledby="headingOne"
                  // data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    {" "}
                    {/* dynamicDropdown */}
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <DataTable
                          title=""
                          columns={getProjectPhase}
                          data={getPhaseData}
                          // progressPending={loading}
                          paginationRowsPerPageOptions={
                            SupplierConstants.ROW_PER_PAGE
                          }
                          pagination
                          // paginationServer
                          // paginationTotalRows={totalRows}
                          // onChangeRowsPerPage={handlePerRowsChange}
                          // onChangePage={handlePageChange}
                          selectableRows
                          // onSelectedRowsChange={handleChange}
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>
      <Row className="mb-4">
        <Col className="d-flex justify-content-end btnActionGroup">
          <button
            type="button"
            className="btnTable btnAction"
            onClick={() => handleSubmit("Save")}
            disabled={disabled}
          >
            <i className="bi bi-save"></i> Create
          </button>

          <button
            type="button"
            className="btnTable btnAction"
            onClick={() => handleSubmit("Draft")}
            disabled={disabled}
          >
            <i className="bi bi-file-earmark"></i> Draft
          </button>
        </Col>
      </Row>
      <FailureModal
        show={getShowFailureModal}
        onHide={() => hideFailureModal()}
        failuremodaldata={getFailureModal}
        requiredfields={getErrorFields}
      />
      <FileViewerModal
        show={getShowFileViewModal}
        onHide={handleViewFileHide}
        fileid={getFileViewData}
      />
      <HeaderText
        index={getHeaderTextIndex}
        headername="Header Text for Line Item"
        show={getLineItemHeaderTextModal}
        onHide={hideLineItemHeaderText}
        hedertextdata={handleHeaderTextLineItemData}
        showcurrentdata={getDataToHeaderText}
        masterdata="POItemTextID"
      />
      <HrProjectServices
        index={getServicesLineItemIndex}
        headername={getServiceTitle}
        show={getServicesLineItemModal}
        onHide={hideServicesLineItem}
        servicescheduledata={handlePhases}
        showcurrentdata={getServicesLineItemText}
        purchasetype={formInputs.purchaseTypeCode}
      />
    </main>
  );
};

export default HrProjectReg;
